import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors, SMSIcon } from '@aftersale-next/ui';
import ChannelOptionButton from './elements/channel-option-button';
export default function SMSOption(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(ChannelOptionButton, {
    label: t('TEXT_MESSAGE'),
    Icon: /*#__PURE__*/_jsx(SMSIcon, {
      background: colors.textForeground
    }),
    accent: colors.appBackground,
    onClick: props.onClick
  });
}